import { Box } from '@terra/ui-styled-system';

export function MenuDivider() {
  return (
    <Box
      w="full"
      py="1"
      display="flex"
      alignItems="center"
      flexShrink={0}
      aria-hidden
    >
      <Box flex="1" h="1px" bg="border.neutral.subtle" />
    </Box>
  );
}
